import React from 'react';
import FileUpload from './ExcelUpload';

function Home() {
  return <FileUpload />;
}

export default Home;
